module.exports = __webpack_public_path__ + "static/flags/SI-a6fa935a215d4123c2ef2ba87ac93558.gif";